(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yh-banner-rotator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yh-banner-rotator')) {
    customElements.define('yh-banner-rotator', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.yh-rotator__slide')];
        this.dots = [...this.querySelectorAll('.yh-rotator__dot')];
        this.pauseBtn = this.querySelector('.yh-rotator__pause');
        this.index = 0;
        this.speed = Math.max(3000, parseInt(this.dataset.speed, 10) || 5000);
        this.userPaused = false;
        this.hovering = false;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.hasAttribute('data-autoplay') && this.slides.length > 1 && !reduce;
        this.dots.forEach((d) => d.addEventListener('click', () => { this.show(+d.dataset.index); this.restart(); }));
        if (this.autoplay && this.pauseBtn) {
          this.pauseBtn.hidden = false;
          this.pauseBtn.setAttribute('aria-pressed', 'false');
          this.pauseBtn.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.pauseBtn.setAttribute('aria-pressed', String(this.userPaused));
            this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
            this.restart();
          });
          this.addEventListener('mouseenter', () => { this.hovering = true; this.stop(); });
          this.addEventListener('mouseleave', () => { this.hovering = false; this.restart(); });
          this.addEventListener('focusin', () => { this.hovering = true; this.stop(); });
          this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) { this.hovering = false; this.restart(); } });
          document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.restart()));
          this.restart();
        }
      }
      disconnectedCallback() { this.stop(); }
      show(i) {
        this.index = (i + this.slides.length) % this.slides.length;
        this.slides.forEach((s, n) => {
          const on = n === this.index;
          s.classList.toggle('is-active', on);
          if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('tabindex'); }
          else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('tabindex', '-1'); }
        });
        this.dots.forEach((d, n) => (n === this.index ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current')));
      }
      stop() { clearInterval(this.timer); this.timer = null; }
      restart() {
        this.stop();
        if (this.autoplay && !this.userPaused && !this.hovering && !document.hidden) {
          this.timer = setInterval(() => this.show(this.index + 1), this.speed);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yh-split-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yh-split-rotator')) {
    customElements.define('yh-split-rotator', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.yh-split__slide')];
        this.dots = [...this.querySelectorAll('.yh-split__dot')];
        this.pauseBtn = this.querySelector('.yh-split__pause');
        this.index = 0; this.userPaused = false; this.hovering = false;
        this.speed = Math.max(3000, parseInt(this.dataset.speed, 10) || 5000);
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.hasAttribute('data-autoplay') && this.slides.length > 1 && !reduce;
        this.dots.forEach((d) => d.addEventListener('click', () => { this.show(+d.dataset.index); this.restart(); }));
        if (this.autoplay && this.pauseBtn) {
          this.pauseBtn.hidden = false;
          this.pauseBtn.setAttribute('aria-pressed', 'false');
          this.pauseBtn.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.pauseBtn.setAttribute('aria-pressed', String(this.userPaused));
            this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
            this.restart();
          });
          this.addEventListener('mouseenter', () => { this.hovering = true; this.stop(); });
          this.addEventListener('mouseleave', () => { this.hovering = false; this.restart(); });
          this.addEventListener('focusin', () => { this.hovering = true; this.stop(); });
          this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) { this.hovering = false; this.restart(); } });
          document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.restart()));
          this.restart();
        }
      }
      disconnectedCallback() { this.stop(); }
      show(i) {
        this.index = (i + this.slides.length) % this.slides.length;
        this.slides.forEach((s, n) => {
          const on = n === this.index;
          s.classList.toggle('is-active', on);
          on ? s.removeAttribute('aria-hidden') : s.setAttribute('aria-hidden', 'true');
          s.querySelectorAll('a').forEach((a) => (on ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
        });
        this.dots.forEach((d, n) => (n === this.index ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current')));
      }
      stop() { clearInterval(this.timer); this.timer = null; }
      restart() {
        this.stop();
        if (this.autoplay && !this.userPaused && !this.hovering && !document.hidden) {
          this.timer = setInterval(() => this.show(this.index + 1), this.speed);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
